import React, { useState } from 'react';

import { useAppInfo } from 'AppState';
import Modal from 'components/Modal/Modal';
import { useNavigate } from 'react-router-dom';

import emailjs from '@emailjs/browser';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';
import YouTubeIcon from '@mui/icons-material/YouTube';

import Logo from '../../logo/Logo';

export default function ContactModal() {
  const {dispatchHome,stateHome} = useAppInfo()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: false, message: '' });

  function handleModal(){
    dispatchHome({"contactUs":false})
    navigate("/")
  }

  function handleHome(){
    dispatchHome({"contactUs":false})
    navigate("/")
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({ success: false, message: '' });

    try {
      const templateParams = {
        title: `Request for demo from ${formData.name}`,
        name: formData.name,
        time: new Date().toLocaleString(),
        message: formData.message,
        email: formData.email
      };

      const response = await emailjs.send(
        'service_v4mtq3i',
        'template_vd9n1je',
        templateParams,
        'qrWjbEvScbDOf9ZYG'
      );

      if (response.status === 200) {
        setSubmitStatus({ 
          success: true, 
          message: 'Thank you for your message! We will get back to you soon.' 
        });
        setFormData({ name: '', email: '', message: '' });
        handleModal()
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('Error sending email:', error);
      setSubmitStatus({ 
        success: false, 
        message: 'Sorry, there was an error sending your message. Please try again later.' 
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
    {stateHome.contactUs && 
    <Modal 
    onClose={handleModal} closeIcon={true} width="50%" height='auto'>
      <div style={{overflowY:"auto"}}>
        <div style={{display:"flex",flexDirection:"column",gap:"1rem",padding:"1rem"}}>
          <div style={{width:"100%",borderRadius:"5px",boxSizing:"border-box"}}>
            <Logo color='black' height='30px' width='150px' type='long'></Logo>
          </div>

          <div style={{padding:"0", width: "100%"}}>
            <h2>Hey there,</h2>
            <h3 style={{fontWeight:"normal"}}>Thank you for your interest.</h3>
            
            <h3 style={{margin:"1rem 0 0 0",padding:0,fontWeight:"normal"}}>Our platform is currently undergoing active development and is exclusively accessible to our Beta Users at the moment.</h3>
            <h3 style={{margin:"1rem 0 0 0",padding:0,fontWeight:"normal"}}>If you're curious about our offerings or interested in joining our Beta program, we'd love to connect with you!</h3>
            
            <form onSubmit={handleSubmit} style={{marginTop: "2rem", width: "100%"}}>
              <div style={{display: "flex", flexDirection: "column", gap: "1rem", width: "100%"}}>
                <div style={{width: "100%"}}>
                  <label htmlFor="name" style={{display: "block", marginBottom: "0.5rem"}}>Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                    style={{
                      width: "100%",
                      padding: "0.75rem",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      boxSizing: "border-box",
                      fontSize: "16px",
                      WebkitAppearance: "none"
                    }}
                  />
                </div>
                
                <div style={{width: "100%"}}>
                  <label htmlFor="email" style={{display: "block", marginBottom: "0.5rem"}}>Email</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                    style={{
                      width: "100%",
                      padding: "0.75rem",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      boxSizing: "border-box",
                      fontSize: "16px",
                      WebkitAppearance: "none"
                    }}
                  />
                </div>
                
                <div style={{width: "100%"}}>
                  <label htmlFor="message" style={{display: "block", marginBottom: "0.5rem"}}>Message</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    disabled={isSubmitting}
                    rows="4"
                    style={{
                      width: "100%",
                      padding: "0.75rem",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      resize: "vertical",
                      boxSizing: "border-box",
                      fontSize: "16px",
                      WebkitAppearance: "none"
                    }}
                  />
                </div>
                
                {submitStatus.message && (
                  <div style={{
                    padding: "0.75rem",
                    borderRadius: "4px",
                    backgroundColor: submitStatus.success ? "#d4edda" : "#f8d7da",
                    color: submitStatus.success ? "#155724" : "#721c24",
                    border: `1px solid ${submitStatus.success ? "#c3e6cb" : "#f5c6cb"}`
                  }}>
                    {submitStatus.message}
                  </div>
                )}
                
                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    padding: "0.75rem 1.5rem",
                    backgroundColor: isSubmitting ? "#666" : "#000",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: isSubmitting ? "not-allowed" : "pointer",
                    fontSize: "1rem",
                    marginTop: "1rem"
                  }}
                >
                  {isSubmitting ? "Sending..." : "Send Message"}
                </button>
              </div>
            </form>

            <div style={{display:"flex",gap:"2rem",marginTop:"2rem",flexDirection:"column"}}>
              <div style={{display:"flex",gap:"2rem"}}>
                <div style={{display:"flex",gap:"1rem",alignItems:"center"}}>
                  <a
                    href="mailto:info@autonomyfinance.ai?subject=Inquiry&body=Hello%20there"
                    style={{
                      color: "black"
                    }}
                  >
                    <EmailIcon fontSize="large" />
                  </a>
                  <h3 style={{color:"black",fontWeight:"normal"}}>info@autonomyfinance.ai</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>}
    </>
  )
}

function SocialMediaHandles(){
  return (
    <div style={{display:"flex",gap:"2rem",alignItems:"center",padding:"1rem 0"}}>
    <a
      href="https://x.com/AutonomyFinance"
      target='blank'
      style={{
        fontSize: "2rem",
        color: "black",
        display:"flex",
        gap:"1rem"
      }}
    >
       <XIcon style={{fontSize:"2rem"}} />
       
    </a>
    <a
      href="https://www.instagram.com/autonomyfinance/"
      target='blank'
      style={{
        fontSize: "2rem",
        color: "black",
        display:"flex",
        gap:"1rem"
      }}
    >
      <InstagramIcon style={{fontSize:"2rem"}} />
    </a>
    <a
      href="https://www.instagram.com/autonomyfinance/"
      target='blank'
      style={{
        fontSize: "2rem",
        color: "black",
        display:"flex",
        gap:"1rem"
      }}
    >
       <YouTubeIcon style={{color:"red",fontSize:"3rem"}}  />
       
    </a>
    </div>
  )
}